import axios from 'axios'

const instance = axios.create({
    baseURL: "https://identitysc.el-turk.com"
})
export default instance
